import { render, staticRenderFns } from "./editRoleModal.vue?vue&type=template&id=0bdd455e&scoped=true"
import script from "./editRoleModal.vue?vue&type=script&lang=js"
export * from "./editRoleModal.vue?vue&type=script&lang=js"
import style0 from "./editRoleModal.vue?vue&type=style&index=0&id=0bdd455e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd455e",
  null
  
)

export default component.exports